<template>
    <div id="service" class="service-container">
        <div class="service-wrapper" />
        <div class="service-body">
            <div class="service-content">
                <p class="service-title">公司简介</p>
                <div class="service-detail">
                    <div v-for="(item, index) in serviceList" :key="index" class="service-detail-info">
                        <img :src="item.logo" alt="">
                        <p class="title">{{ item.name }}</p>
                        <p class="label">{{ item.remark }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Service',
    data() {
        return {
            serviceList: [
                {
                    remark: '点酷网络信息技术有限公司成立于 2017 年,由享有盛誉的业界翘楚企业共同投资成立,主要业务涉及交通卡充值消费、实时公交、线上商城等,是一家致力于服务市民,以提升市民出行便利与生活的体验为宗旨的新锐高新技术...',
                    logo: require('../../assets/image/finger.png')
                }
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
.service-container {
    width: 100%;
    position: relative;
    padding: 80px 0 40px;
    box-sizing: border-box;
    background: linear-gradient(180deg, #ffffff 0%, #eff6ff 100%);

    .service-wrapper {
        display: none;
    }

    .service-body {
        width: 100%;
        padding: 0 16px;
        box-sizing: border-box;
    }

    .service-content {
        width: 100%;
        max-width: 1200px;
        margin: 0 auto;
        padding: 32px;
        box-sizing: border-box;
        background: #ffffff;
        border-radius: 24px;
        box-shadow: 0 16px 40px rgba(0, 0, 0, 0.08);

        .service-title {
            font-size: 36px;
            font-weight: 700;
            color: #0f1b3d;
            margin-bottom: 24px;
            text-align: left;
        }

        .service-detail {
            display: flex;
            justify-content: space-between;
            gap: 16px;
            flex-wrap: wrap;

            .service-detail-info {
                flex: 1 1 360px;
                min-width: 260px;
                padding: 24px;
                background: #f9fbff;
                border-radius: 24px;
                box-shadow: 0 10px 24px rgba(0, 0, 0, 0.06);

                img {
                    width: 60px;
                    height: 60px;
                    display: block;
                    margin-bottom: 18px;
                }

                .title {
                    font-size: 22px;
                    color: #1f2a44;
                    line-height: 1.4;
                    margin-bottom: 16px;
                    font-weight: 600;
                }

                .label {
                    font-size: 16px;
                    color: #5f6679;
                    line-height: 28px;
                    white-space: normal;
                }
            }
        }
    }
}

@media (max-width: 768px) {
    .service-container {
        padding: 24px 0 20px;
    }

    .service-body {
        padding: 0 12px;
    }

    .service-content {
        padding: 20px;
        box-shadow: none;
        border-radius: 20px;
        background: #ffffff;
    }

    .service-title {
        font-size: 28px;
        line-height: 36px;
        margin-bottom: 18px;
    }

    .service-detail {
        display: block;
    }

    .service-detail-info {
        width: 100%;
        padding: 18px;
        margin-bottom: 16px;
        background: #f5f8ff;
        border-radius: 20px;
        box-shadow: none;
    }

    .service-detail-info img {
        width: 50px;
        height: 50px;
        margin-bottom: 16px;
    }

    .service-detail-info .title {
        font-size: 20px;
        margin-bottom: 12px;
    }

    .service-detail-info .label {
        font-size: 14px;
        line-height: 24px;
    }
}
</style>
